<button id="submitpopup" style="display:none;" data-toggle="modal" data-target="#submit_popup"></button>
<div class="modal fade " id="submit_popup" role="dialog">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
      <div class="modal-header">
        <h4 class="modal-title">Approve Decisions</h4>
      </div>
      <div class="modal-body" style="text-align:center;">
       You still have decisions forms that need to be approved.
      <div class="return_to_simulation">
        <a href="javascript:void(0)" data-dismiss="modal" (click)="decisionStatusPage()">[Return to Decision Status Page]</a>
      </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">ok</button>
      </div>
    </div>
  </div>
</div>
